import LegalAgreementEdit from './LegalAgreementEdit';
import WebUniversal, { WebUniversalProps } from '../../system/WebUniversal';
import { columnsheadId } from '../../universal/columnshead';
import { Switch } from 'antd';
import dayjs from 'dayjs';

//组件 
const WebComponent = (props: any) => {

    /** api服务id */
    const apiId = 'legalAgreement';

    //表头
    const columnsHead = [
        {
            title: '协议名',
            dataIndex: 'agreementName'
        },
        {
            title: '起始日期',
            dataIndex: 'startDate',
            render: (text: any) => dayjs(text).format('YYYY-MM-DD')
        },
        {
            title: '结束日期',
            dataIndex: 'endDate',
            render: (text: any) => dayjs(text).format('YYYY-MM-DD')
        },
        {
            title: '默认',
            dataIndex: 'isDefault',
            render: (text: any, record: any) => (
                <Switch checkedChildren="是" unCheckedChildren="否"
                    checked={text} key={record.id}
                />
            )
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    const extendProps: WebUniversalProps = {
        ...props,
        titleName: '法律协议',
        apiId,
        columns,
        editOptions: {
            Editor: LegalAgreementEdit
        }
    };
    return (<WebUniversal {...extendProps} />)
}

export default WebComponent;
